import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24 px-4 md:px-8" aria-label="分类导航">
      <div className="max-w-6xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-primary-500 text-primary-500 text-xs font-medium mb-5">
          六大分类
        </span>
        <h2 className="font-heading text-3xl md:text-4xl text-primary-500 leading-tight">
          你想看什么瓜？
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
          六大精选分类，覆盖全网最热门的吃瓜领域，总有一种爆料能吸引你
        </p>

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group text-left rounded-xl bg-background-50 p-5 md:p-6 hover:bg-primary-500 transition-colors duration-300"
            >
              <div className="w-10 h-10 rounded-lg bg-secondary-100 flex items-center justify-center mb-4 group-hover:bg-accent-500 transition-colors">
                <i className={`${cat.icon} w-5 h-5 flex items-center justify-center text-secondary-700 group-hover:text-background-50 transition-colors`} />
              </div>
              <h3 className="font-heading text-lg md:text-xl text-foreground-800 group-hover:text-background-50 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 group-hover:text-background-100/80 transition-colors line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400 group-hover:text-background-200 transition-colors">
                <span>{cat.articleCount} 篇爆料</span>
                <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}